import { TextField as MuiTextField } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { getReccurssiveObjectKeys } from '../../utils/common';

export const TextField = ({ name, fullWidth, sx, ...props }) => {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      defaultValue=""
      render={({ field, formState: { errors } }) => (
        <MuiTextField
          error={!!getReccurssiveObjectKeys(errors, name)}
          {...field}
          {...props}
          sx={{
            ...sx,
            '& .MuiInputBase-input': { px: 1, py: 0.5, fontSize: '1.2rem' },
            '& .MuiInputBase-input:focus': { backgroundColor: '#E0F7F7' },
            '& .Mui-disabled': { backgroundColor: '#f0ffff' },
            ...(props.type === 'radio' && {
              '& .MuiOutlinedInput-notchedOutline': { border: 'none' }
            })
          }}
          fullWidth={fullWidth}
          // helperText={errors[name]?.message?.toString()}
        />
      )}
    />
  );
};
